var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-layout"},[_c('admin-nav'),_vm._v(" "),_c('div',{staticClass:"admin-layout-body",attrs:{"id":"scroll-target"}},[_c('app-header'),_vm._v(" "),_c('app-content')],1),_vm._v(" "),_c('app-modal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bd5ef1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/admin/Layout.vue
// module id = null
// module chunks = 